import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import ChatBubble from './ChatBubble';

export default function ChatMessageList({ messages, emptyHint, onPromptClick }) {
  const { t } = useTranslation();
  const bottomRef = useRef(null);
  const containerRef = useRef(null);
  const [autoScroll, setAutoScroll] = useState(true);

  useEffect(() => {
    if (autoScroll) bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, autoScroll]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    setAutoScroll(scrollHeight - scrollTop - clientHeight < 80);
  };

  const prompts = [
    t('chatbot.suggested.p1', "Comment structurer un atelier 1 ?"),
    t('chatbot.suggested.p2', "Qu'est-ce qu'un scénario opérationnel ?"),
    t('chatbot.suggested.p3', 'Comment évaluer la vraisemblance ?'),
    t('chatbot.suggested.p4', 'Quelles techniques MITRE pour le phishing ?'),
  ];

  return (
    <div ref={containerRef} onScroll={handleScroll} className="flex-1 overflow-y-auto px-4 py-3">
      {messages.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-center">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center mb-3 shadow-md">
            <Sparkles size={22} className="text-white" />
          </div>
          <p className="text-sm text-gray-500 max-w-[260px] mb-4">{emptyHint}</p>
          {onPromptClick && (
            <div className="flex flex-col gap-2 w-full max-w-[280px]">
              <p className="text-[10px] uppercase tracking-wide text-gray-400 mb-1">
                {t('chatbot.suggested.title', 'Essayez')}
              </p>
              {prompts.map((p, i) => (
                <button
                  key={i}
                  onClick={() => onPromptClick(p)}
                  className="text-left text-xs px-3 py-2 rounded-lg border border-gray-200 bg-white hover:border-blue-400 hover:bg-blue-50 transition-colors"
                >
                  {p}
                </button>
              ))}
            </div>
          )}
        </div>
      ) : (
        messages.map((m, i) => <ChatBubble key={i} message={m} />)
      )}
      <div ref={bottomRef} />
    </div>
  );
}
